import React, { useState } from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';

export type MenuNavProps = {
    label: string, options?: { label: string, onClick: () => void }[]
}

export default function MenuNav(props: MenuNavProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Typography
                variant='h6'
                onClick={handleClick}
            >
                {props.label}
            </Typography>
            {props.options && props.options.length > 0 && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    {props.options.map((option, index) => (
                        <MenuItem key={index} onClick={() => {option.onClick(); handleClose()}}>
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </div>
    );
}